/**
 * formatLeadsCount
 *
 * Formats a numeric leads count using compact notation
 * (e.g. 1200 → 1.2K, 1000000 → 1M) based on locale.
 *
 * @param {number} value - Numeric leads count
 * @param {string} locale - Intl locale (e.g. 'en', 'uk', 'de')
 * @returns {string}
 */
export function formatLeadsCount(value, locale = 'en') {
    const numericValue = Number(value);

    if (!Number.isFinite(numericValue)) {
        return String(value);
    }

    return new Intl.NumberFormat(locale, {
        notation: 'compact',
        compactDisplay: 'short',
        maximumFractionDigits: 1,
    }).format(numericValue);
}
